import org from './manage/org.js'
import systemSetting from './manage/systemSetting.js'
import assetLedger from './manage/assetLedger.js'
import resource from './manage/resource.js'
import course from './manage/course.js'
import softWare from './manage/softWare.js'
import analysis from './manage/analysis.js'
import board from './manage/board.js'

export default [{
	path: '/sys',
	component: () => import('../sys/home'),
	redirect: '/sys/index',
	children: [{
		path: 'index',
		component: () => import('../sys/index'),
		meta: {
			title: '后台管理-主页'
		}
	},
	{
		path: 'resource',
		component: () => import('../sys/resource-center/r_library/index'),
		meta: {
			title: '后台管理-资源库'
		}
	},
	{
		path: 'personalCenter',
		component: () => import('../sys/system/personalCenter/index'),
		meta: {
			title: '个人中心'
		},
		children: [{
			path: 'editPwd',
			component: () => import('../sys/system/personalCenter/editPwd')
		}]
	},
	//组织架构管理
	...org,
	//系统设置
	...systemSetting,
	//实训室资产台账
	...assetLedger,
	//用户管理
	{
		path: 'user',
		component: () => import('../sys/system/user/index')
	},
	//产品管理
	{
		path: 'product',
		component: () => import('../sys/product/index'),
	},
	// 资源管理
	...resource,
	//题库管理
	{
		path: 'questions',
		component: () => import('../sys/teaching/questions')
	},
	//课程管理
	...course,
	//软件数据管理
	...softWare,
	//统计分析
	...analysis,
	// 平台管理
	{
		path: "sysManage",
		component: () => import('../sys/appConfig/index'),
	},
	{
		path: 'feedback',
		component: () => import('../sys/system/feedback.vue'),
		meta: {
			title: '后台管理-反馈管理'
		}
	},
	{
		path: 'operation-log',
		component: () => import('../sys/system/requestLog.vue'),
		meta: {
			title: '后台管理-操作日志'
		}
	}, {
		path: 'permission',
		component: () => import('../sys/system/role/roleManage.vue'),
		meta: {
			title: '后台管理-权限管理'
		}
	}, {
		path: 'textMatching',
		// 功能已并入「系统设置」的选项卡，这里保留旧地址可直接到达
		redirect: '/sys/systemSetting?tab=textMatching',
		meta: {
			title: '后台管理-对话匹配阈值设置'
		}
	}, {
		path: 'modelProvider',
		component: () => import('../sys/modelProvider/index.vue'),
		meta: {
			title: '后台管理-模型管理'
		}
	}
	]
},
//数据大屏
...board
]